import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { buttonVariants } from '@mdvip/shared/components/ui/button';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * The site-wide fallback for any route that doesn't match — registered as the last, catch-all
 * route inside each app's protected route group, so an unregistered or removed path renders a
 * real page instead of a blank content area inside AppLayout's chrome.
 */
export function NotFoundPage() {
  const { t } = useTranslation('shared');

  return (
    <div className="flex flex-col items-center gap-6 rounded-xl px-6 py-16 text-center">
      <div className="flex size-16 items-center justify-center rounded-full bg-secondary">
        <Icon name="mapPin" size="xl" className="text-[26px] text-muted-foreground" />
      </div>
      <div className="flex max-w-md flex-col gap-2">
        <h1 className="text-h1 font-semibold text-foreground">{t('notFound.title')}</h1>
        <p className="text-base leading-relaxed text-muted-foreground">{t('notFound.message')}</p>
      </div>
      <Link to="/" className={buttonVariants()}>
        {t('errors.goHome')}
      </Link>
    </div>
  );
}
